import { S3_IMAGES_URL } from 'constants/index'
import localCoinIcon from 'assets/images/icons/png/coin.svg'
import localWalletCoins from 'assets/images/icons/png/wallet-balance-coins.svg'
import localBonusIcon from 'assets/images/icons/png/bonus.svg'
import localCashbackIcon from 'assets/images/icons/png/cashback.svg'
import localRewardBox from 'assets/images/icons/png/reward-box.svg'
import localDailyBonus from 'assets/images/icons/png/daily-bonus.svg'
import localWeeklyBonus from 'assets/images/icons/png/weekly-bonus.svg'
import localReferralBonus from 'assets/images/icons/png/referral-bonus.svg'
import localWeeklyReward from 'assets/images/icons/png/weeklyreward.svg'
import localMonthlyReward from 'assets/images/icons/png/monthlyreward.svg'
import localRakebackReward from 'assets/images/icons/png/rakebackreward.svg'
import localTotalReward from 'assets/images/icons/png/totalreward.svg'
import localOtherReward from 'assets/images/icons/png/otherreward.svg'
import localRewardImg from 'assets/images/icons/png/reward-img.svg'
import localUsdtIcon from 'assets/images/crypto-icons/usdt.png'
import localEthIcon from 'assets/images/crypto-icons/eth.png'
import localLoginImg from 'assets/images/login.webp'
import localMineImg from 'assets/images/icons/png/mine.svg'
import localHiloImg from 'assets/images/icons/png/hilo.svg'
import localCoinFlipImg from 'assets/images/icons/png/coin-flip.svg'
import localCrashImg from 'assets/images/icons/png/crash.svg'
import localPlinkoImg from 'assets/images/icons/png/plinko.svg'
import localDefaultAvatar from 'assets/images/icons/png/default-avatar.svg'

export const americanFootball = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/american-football.webp`
export const clutchGameLogo = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/clutch-game-logo.webp`
export const provider1 = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/provider-1.webp`
export const goldICon = localCoinIcon
export const goldCoin25x25Icon = localCoinIcon
export const teamIcon1 = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/table-icon.webp`
export const AuthBacheartkgroundPng = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/heart.webp`
export const Fullscreen = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/zoom.webp`
export const casino = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/casino.webp`
export const AuthBackgroundPng = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/auth-bg.webp`
export const RewardBox = localRewardBox
export const earthIcon = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/earth.webp`
export const eth = localEthIcon
export const Bonus = localBonusIcon
export const Cashback = localCashbackIcon
export const Mini = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/Mini.webp`
export const PokerGames = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/poker-games.webp`
export const Promotion = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/promotion.webp`
export const Community = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/Community.webp`
export const ecoSports = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/rank-sport.png`
export const ecoCasino = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/rank-casino.png`
export const ecoFutures = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/rank-futures.png`
export const hotGames = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/clutch-dices.png`
export const clutchWhitepaper = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/clutch-book.png`
export const vipRanked = '/assets/images/ranks/vip.svg'
export const casinoCardAndCoins = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/cards-and-coin.png`
export const casinoStonesAndCrown = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/clutch-xp-crown.png`
export const casinoSportCash = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/sport-cash.png`
export const mine = localMineImg
export const hilo = localHiloImg
export const coinFlip = localCoinFlipImg
export const crash = localCrashImg
export const casinoHeading = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/casino-heading-ico.webp`
export const defaultGameImage = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/defaultGameImage.webp`
export const tennis = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/tennis.webp`
export const baseball = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/baseball.webp`
export const iceHockey = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/ice-hockey.webp`
export const premierLeague = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/premier-league.webp`
export const leagueOfLegends = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/league-of-legends.webp`
export const formulaOne = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/formulaOne.webp`
export const ClutchGameOn = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/clutch-game-on.webp`
export const ProfileImg = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/profileImg.webp`
export const defaultAvatar = localDefaultAvatar
export const plinko = localPlinkoImg
export const fifa = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/fifa.webp`
export const mma = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/mma.webp`
export const boxing = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/boxing.webp`
export const counterStrike = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/counter-strike.webp`
export const cricket = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/cricket.webp`
export const dota = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/dota.webp`
export const rugbyLeague = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/rugby-league.webp`
export const rugbyUnion = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/rugby-union.webp`
export const valorant = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/valorant.webp`
export const golf = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/golf.webp`
export const clutchWalletIcon = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/clutch-wallet-icon.webp`
export const peopleIcon = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/age-icon.webp`
export const crashHistoryIcon = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/you-icon.webp`
export const mixCoin = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/mix-coin.webp`
export const modalCashout = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/modal-cashout.webp`
export const modalDown = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/modal-down.webp`
export const modalInfo = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/modal-info.webp`
export const modalMultiplier = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/modal-multiplier.webp`
export const modalUp = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/modal-up.webp`
export const coinFlipHeads = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/heads.webp`
export const coinFlipTails = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/tails.webp`
export const rollerCoaster = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/vector.webp`
export const sideFox = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/side-fox.webp`
export const googleCut = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/google-cut.webp`
export const AffiliateCardOne = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/affiliate-card-1.webp`
export const AffiliateCardTwleagueOfLegendso = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/affiliate-card-2.webp`
export const AffiliateCardThree = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/affiliate-card-3.webp`
export const AffiliateCardFour = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/affiliate-card-4.webp`
export const AffiliateCardFive = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/affiliate-card-5.webp`
export const rewardCards = localRewardBox
export const rewardCoins = localWalletCoins
export const rewardStone = localRewardBox
export const rewardBadge = localRewardBox
export const rewardGiftBox = localRewardBox
export const twitchCut = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/twitch-cut.webp`
export const phantomCut = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/phantom-cut.webp`
export const rewardsVisa = '/assets/images/cashier/visa.webp'
export const usdtIcon = localUsdtIcon
export const balanceCoins = localWalletCoins
export const heart = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/heart.webp`
export const walletBalanceCoins = localWalletCoins
export const dailybonus = localDailyBonus
export const weeklybonus = localWeeklyBonus
export const dailyreward = localRewardBox
export const referralBonus = localReferralBonus
export const referralBonusSmall = localReferralBonus
export const dailybonusSmall = localDailyBonus
export const weeklybonusSmall = localWeeklyBonus
export const cashbackSmall = localCashbackIcon
export const specialBonusSmall = localBonusIcon

export const weeklyreward = localWeeklyReward
export const monthlyreward = localMonthlyReward
export const rakebackreward = localRakebackReward
export const otherreward = localOtherReward
export const totalreward = localTotalReward
export const gamingCuracao = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/gaming-curacao.webp`
export const emailVerifyImage = `${S3_IMAGES_URL.IMAGE_URL}/images/verify-email.webp`
export const updatePasswordImg = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/update-pass-img.webp`
export const withdrawRequestImg = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/withdrawal-req-img.webp`
export const providersImg = `${S3_IMAGES_URL.IMAGE_URL}/assets/Icons/png/Providers.png`
export const loginImg = localLoginImg
export const registerImg = localLoginImg
export const rewardsImage = localRewardImg
export const usElections = `${S3_IMAGES_URL.IMAGE_URL}/images/harris-trump.webp`
export const gigadatDeposit = `${S3_IMAGES_URL.IMAGE_URL}/images/gigadat-deposit.png`
export const gigadatWithdraw = `${S3_IMAGES_URL.IMAGE_URL}/images/gigadat-withdraw.png`
export const bannerSignupBonus = `${S3_IMAGES_URL.IMAGE_URL}/images/signup-bonus-banner.webp`
export const cryptoDepositImg = `${S3_IMAGES_URL.IMAGE_URL}/images/crypto-deposit.webp`

// sports book - betby navigation (served from public/assets/betby/)
export const sportsbookBanner_boxingTab     = '/assets/betby/betby-boxing.png'
export const sportsbookBanner_cricketImage  = '/assets/betby/betby-cricket.png'
export const sportsbookBanner_F1Tab         = '/assets/betby/betby-f1.png'
export const sportsbookBanner_GolfTab       = '/assets/betby/betby-golf.png'
export const sportsbookBanner_NBATab        = '/assets/betby/betby-nba.png'
export const sportsbookBanner_NFLTab1       = '/assets/betby/betby-nfl.png'
export const sportsbookBanner_NHLTab        = '/assets/betby/betby-soccer.png'
export const sportsbookBanner_NRLTab        = `${S3_IMAGES_URL.IMAGE_URL}/banner/betby/NRL.jpg`
export const sportsbookBanner_SoccerTab2    = '/assets/betby/betby-soccer.png'
export const sportsbookBanner_TennisTab     = '/assets/betby/betby-tennis.png'
export const sportsbookBanner_CLGfb         = '/assets/betby/betby-college-football.png'
export const sportsbookBanner_MMA           = '/assets/betby/betby-mma.png'
export const sportsbookBanner_MMA2          = '/assets/betby/betby-mma-2.png'
export const promGirl                       = `${S3_IMAGES_URL.IMAGE_URL}/banner/prom-girl.jpg`
export const sportsbookBanner_CueSport      = `${S3_IMAGES_URL.IMAGE_URL}/banner/betby/CueSports%20.png`
export const sportsTennis                   = '/assets/betby/betby-tennis.png'
